import React, { useState, useContext } from "react";
import { css } from "emotion";
import Color from "color";
import { BlockPicker, SliderPicker } from "react-color";
import GenericCard from "../GenericCard";
import { boxStyles, textSizes } from "../../styles/theme";
import { BuildContext } from "../../context/BuildSpotlightState";
import { EditContext } from "../../context/EditSpotlightState";

const BackgroundColorPicker = ({ forEdit }) => {
  const {
    primaryColor,
    setPrimaryColor,
    setSecondaryColor,
    colorOptions,
  } = useContext(forEdit ? EditContext : BuildContext);

  // Change this to true to collapse it when it loads by default and click to expand
  const [collapsed, setCollapsed] = useState(false);

  const updateColors = (color) => {
    const newColor = Color(color.hex);
    const contrast = newColor.contrast(Color("#FFF"));
    const contrastLimit = 2;

    setPrimaryColor(color.hex);
    setSecondaryColor(contrast > contrastLimit ? "#FEFEFE" : "#0A0A0A");
  };

  const handleClick = () => {
    setCollapsed(false);
  };

  return (
    <GenericCard style={container}>
      <div className={collapsed ? "collapsed" : ""} onClick={handleClick}>
        <BlockPicker
          width="100%"
          color={primaryColor}
          onChangeComplete={updateColors}
          triangle="hide"
          colors={colorOptions}
        />
        <div className="hue-container">
          <SliderPicker
            color={primaryColor}
            onChange={updateColors}
            width="100%"
          />
        </div>
      </div>
    </GenericCard>
  );
};

export default BackgroundColorPicker;

const container = css`
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  overflow: visible;
  box-shadow: none;
  flex-direction: column;
  box-shadow: 0 2px 8px #00000029 !important;
  max-width: 250px;
  margin: auto;

  div:nth-child(1) {
    width: 100%;
  }

  .block-picker {
    display: block;
    box-shadow: none !important;
    width: 100%;

    div:nth-child(2) {
      max-height: 80px;

      div {
        text-align: center;
      }
    }

    span {
      div {
        border: 1px solid #efefef;
      }
    }

    input {
      background-color: #efefef;
      padding: 2px 8px !important;
      height: 26px !important;
      margin-top: 10px;
      box-shadow: none !important;
    }
  }

  .hue-container {
    width: 100%;
    padding: 15px 10px;
    box-sizing: border-box;
    border-top: 1px solid #efefef;
  }

  .collapsed {
    width: 100%;
    overflow: hidden;
    border-radius: 8px;

    .block-picker {
      div:nth-child(3) {
        display: none;
      }
    }

    .hue-container {
      display: none;
    }
  }

  p {
    color: white;
    font-size: ${textSizes.normal};
  }
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: 50%;
  }
`;
